import React, { useState } from 'react';

// Valor de texto que el propio jugador puede editar en el sitio (alias,
// correo). Guarda al pulsar Guardar; `onGuardar` devuelve el valor ya
// normalizado por el servidor. Vacío = borrar el valor.
export default function CampoEditable({ id, etiqueta, valor, vacio, placeholder, type = 'text', onGuardar }) {
  const [editando, setEditando] = useState(false);
  const [borrador, setBorrador] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState(null);

  const empezar = () => { setBorrador(valor ?? ''); setError(null); setEditando(true); };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setError(null);
    try {
      await onGuardar(borrador.trim() || null);
      setEditando(false);
    } catch (err) {
      setError(err.message || 'No se pudo guardar.');
    } finally {
      setGuardando(false);
    }
  };

  if (!editando) {
    return (
      <div className="mz-campo">
        <span className="mz-campo-etiqueta">{etiqueta}</span>
        <span className={valor ? 'mz-campo-valor' : 'mz-campo-valor mz-vacio'}>{valor || vacio}</span>
        <button type="button" className="btn btn-secondary btn-sm" onClick={empezar} aria-label={`Editar ${etiqueta.toLowerCase()}`}>
          Editar
        </button>
      </div>
    );
  }

  return (
    <form className="mz-campo mz-campo-edicion" onSubmit={guardar}>
      <label className="mz-campo-etiqueta" htmlFor={id}>{etiqueta}</label>
      <input id={id} type={type} value={borrador} placeholder={placeholder} onChange={(e) => setBorrador(e.target.value)} autoFocus />
      <button type="submit" className="btn btn-primary btn-sm" disabled={guardando}>{guardando ? 'Guardando…' : 'Guardar'}</button>
      <button type="button" className="btn btn-secondary btn-sm" disabled={guardando} onClick={() => setEditando(false)}>Cancelar</button>
      {error && <p className="msg-error mz-campo-error" role="alert">{error}</p>}
    </form>
  );
}
